import React from 'react';
import AsyncCoinContractABI from '../../../build/contracts/AsyncCoin';
import { ASYNC_NETWORK_ID } from '../../utils/Constants';
import { FINISH_STEP } from '../../storage/TutorialReducer';
import { withRouter } from 'react-router-dom';

class TutorialStep1 extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      contractAddress: null
    };
  }

  componentDidMount () {
    if (this.props.location.pathname !== '/') {
      this.props.history.push('/');
    }

    this.setState({
      contractAddress: AsyncCoinContractABI.networks[ASYNC_NETWORK_ID].address
    });
  }

  goNext () {
    Storage.dispatch({type: FINISH_STEP, payload: 1});
  }

  render () {
    return (
      <div className="c-tutorial-element">
        <h2>Welcome to AsyncCoin!</h2>
        <h3 className="c-tutorial-element__subtitle">What is AsyncCoin?</h3>
        <p>
          AsyncCoin is showcase Dapp developed by <a href="https://www.asynclabs.co" target="_blank">AsyncLabs</a>.
          AsyncCoin itself is
          standard ERC20 token, but we have added few features to make it a little more interesting. AsyncCoin is
          mintable, which means there is no fixed cap on the total AsyncCoin that can be in the circulation. Other than
          the standard
          transferring of AsyncCoin, there is an option to redeem the Coupons created by the Dapp owner, buying
          AsyncCoin with
          Ether, and setting the name of your address inside the AsyncCoin Dapp.
        </p>

        <div className="c-tutorial-element__button-container">
          <button onClick={this.goNext}>Next</button>
        </div>
      </div>
    );
  }
}

export default withRouter(TutorialStep1);



// WEBPACK FOOTER //
// ./src/components/Tutorial/TutorialStep1.js